<canvas
  #canvas
  class="w-full rounded-xl border border-gray-400"
></canvas>

<div class="buttons flex justify-between">
  <button (click)="clearPad()">Vider</button>
</div>
